/* Reader actions only: never send calculator inputs, outputs, link text or URL queries. */
(function () {
    if (window.jhReaderEventsInstalled || document.body.dataset.jhReaderEvents === 'false') return;
    window.jhReaderEventsInstalled = true;

    // These are cited institutions, not a blanket assumption that every external link is official.
    const officialHosts = [
        'clp.com.hk', 'clpgroup.com', 'hkelectric.com', 'towngas.com', 'mtr.com.hk',
        'hongkongairport.com', 'hsi.com.hk', 'hkex.com.hk', 'hkexnews.hk', 'hkma.gov.hk',
        'hkab.org.hk', 'mpfa.org.hk', 'hkmc.com.hk', 'housingauthority.gov.hk', 'hkhs.com',
        'ha.org.hk', 'vhis.gov.hk', 'consumer.org.hk', 'hsbc.com.hk', 'hangseng.com',
        'bochk.com', 'sc.com', 'citibank.com.hk', 'dbs.com.hk', 'mox.com',
        'livi.com.hk', 'bank.za.group', 'welab.bank', 'airstarbank.com', 'antbank.hk',
        'fubonbank.com.hk', 'chiyubank.com', 'cncbinternational.com', 'hkbea.com', 'bankcomm.com.hk',
        'ccb.com', 'icbcasia.com', 'dahsing.com', 'gleneagles.hk', 'cuhkmc.hk',
        'hksh.com', 'hksh-healthcare.com', 'hkbh.org.hk', 'pbh.hk', 'tsuenwanadventist.org.hk',
        'hkah.org.hk', 'evanhosp.com.hk', 'stpaul.org.hk', 'sth.org.hk', 'hongkongahc.com',
        'cmer.com.hk', 'claritymedical.com', 'hysan.com.hk', 'leegardens.com.hk', 'harbourcity.com.hk',
        'ifc.com.hk', 'k11musea.com', 'elementshk.com', 'citygateoutlets.com.hk', 'festivalwalk.com.hk',
        'tmtp.com.hk', 'telford-plaza.com', 'newtownplaza.com.hk', 'linkhk.com', 'thewai.com',
        '11skies.com', 'theapm.com.hk', 'pacificplace.com.hk', 'dps.org.hk', 'blackrock.com',
        'hangsenginvestment.com', 'federalreserve.gov', 'elebank.com', 'livibank.com', 'shacombank.com.hk',
        'publicbank.com.hk', 'pingandb.com', 'fusionbank.com', 'sunshinelaundry.com.hk', 'voguelaundry.com',
        'laundry.servicehk.com', 'whalewashmk.hk', 'sino.com', 'splusrewards.com.hk', 'medhealth.com.hk',
        'vanguard.com', 'ishares.com', 'ssga.com', 'irs.gov', 'revenue.ie',
        'pokoi.org.hk', 'alipayhk.com', 'aeon.com.hk', 'hk.bankcomm.com', 'wewacard.com',
        'primecredit.com', 'thesim.com', 'hkicl.com.hk', 'media.k11.com', 'hzmbparking.com.hk',
        'nlb.com.hk', 'autoparking.hkairport.com', 'asiaworld-expo.com', 'hkairportbooking.com', 'cityplaza.com',
        'timessquare.com.hk', 'thesouthside.com.hk', 'hanglung.com', 'arcade.cyberport.hk', 'harbournorth.com.hk',
        'lgloyaltyprd.blob.core.windows.net', 'thewaimall.com', 'megabox.com.hk', 'moko.com.hk', 'taipomegamall.shkp.com',
        'popcorntko.com.hk', 'yohomall.hk', 'vcity.com.hk', 'tsuenwanplaza.com.hk', 'thepoint.com.hk',
        'metroplaza.com.hk', 'mostown.com.hk', 'mostown-data-live.hld.com.hk', 'hldclub.com', 'shatinplazacentre.com.hk',
        'plazaascot.com', 'citywalk.com.hk', 'onenorth.com.hk', 'tuenmunmtrmalls.com', 'pay.wechat.com',
        'kf.qq.com', 'sfc.hk', 'finra.org', 'sec.gov', 'investor.gov',
        'futuhk.com', 'itiger.com', 'usmart.hk', 'usmart66.com', 'hk.usmartglobal.com',
        'webull.hk', 'bsgroup.com.hk', 'eddid.com.hk', 'interactivebrokers.com.hk',
        'tigerbrokers.com.hk', 'hk.tigeractivity.com', 'poems.com.hk', 'chiefgroup.com.hk',
        'vbkr.com', 'octopus.com.hk', 'wise.com', 'statrys.com',
        'personalsolution.transunion.hk', 'www.transunion.hk', 'newsroom.transunion.hk',
        'www.pcpd.org.hk', 'www.welend.hk', 'www.uaf.com.hk',
        'flightdelaypass.mastercard.com', 'd3pyhjntl5kcs.cloudfront.net'];
    const calculators = [
        ['hkElecCalc', ['heTotal']], ['whCalcBox', ['whElec', 'whGas']],
        ['wdCalcBox', ['wdTotal']], ['applianceCalc', ['arResult']],
        ['movingCalcBox', ['moveTotalResult']], ['acCostCalc', ['acMonthly']],
        ['dhCalcBox', ['dhCost']], ['elCalcBox', ['elSave']],
        ['fridgeCalcBox', ['frYear']], ['dsrCalc', ['dsrTotal']],
        ['stressCalc', ['scPmt']], ['marginForm', ['intOut']],
        ['passive-income-calculator', ['pi-result']], ['hsiDcaCalc', ['hsiFuture']]
    ];
    const usedCalculators = new Set();
    const pending = new Map();
    const articlePath = /^\/[a-z0-9]+(?:-[a-z0-9]+)*\/$/;
    const excludedPaths = new Set(['/about/', '/rss/']);
    const publicArchivePath = /^\/(?:tag|author)\/[a-z0-9]+(?:-[a-z0-9]+)*\/$/;
    const archivePage = /^\/page\/\d+\/$/;
    const pagePath = articlePath.test(window.location.pathname) || publicArchivePath.test(window.location.pathname) || archivePage.test(window.location.pathname) ? window.location.pathname : '/';

    function send(name, fields) {
        if (typeof window.gtag !== 'function') return false;
        window.gtag('event', name, Object.assign({page_path: pagePath}, fields));
        return true;
    }
    function validOutput(id) {
        const element = document.getElementById(id);
        const text = element ? element.textContent : '';
        return /\d/.test(text) && !/NaN|Infinity|請輸入|請先|無效/.test(text);
    }
    function calculatorAction(target, delay, realtime) {
        const definition = calculators.find(function (item) {
            const box = document.getElementById(item[0]);
            return box && box.contains(target);
        });
        if (!definition || usedCalculators.has(definition[0])) return;
        // Other calculators require pressing Calculate; an edited input can still show a stale result.
        if (realtime && definition[0] !== 'hkElecCalc') return;
        const id = definition[0];
        window.clearTimeout(pending.get(id));
        pending.set(id, window.setTimeout(function () {
            pending.delete(id);
            if (!usedCalculators.has(id) && definition[1].every(validOutput) &&
                send('calculator_result', {calculator_id: id})) usedCalculators.add(id);
        }, delay));
    }
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target || !target.closest) return;
        const button = target.closest('button, input[type="submit"]');
        if (button) calculatorAction(button, 0);
        const link = target.closest('a[href]');
        if (!link) return;
        let destination;
        try { destination = new URL(link.href, window.location.href); } catch (error) { return; }
        if (!/^https?:$/.test(destination.protocol)) return;
        if (destination.origin === window.location.origin) {
            if (articlePath.test(destination.pathname) && !excludedPaths.has(destination.pathname) &&
                destination.pathname !== window.location.pathname &&
                link.closest('.gh-content, .gh-feed, .jh-card-grid, .jh-hero-guide')) {
                send('related_guide_click', {guide_path: destination.pathname});
            }
        } else if (link.closest('.gh-content') && (destination.hostname.endsWith('.gov.hk') ||
            officialHosts.some(function (host) {
                return destination.hostname === host ||
                    (!host.endsWith('.cloudfront.net') && destination.hostname.endsWith('.' + host));
            }))) {
            send('official_source_click', {destination_domain: destination.hostname});
        }
    });
    ['input', 'change'].forEach(function (eventName) {
        document.addEventListener(eventName, function (event) {
            if (event.target && event.target.matches('input, select')) calculatorAction(event.target, 750, true);
        });
    });
})();
